import TaskAlt from '@mui/icons-material/TaskAlt';

import { Tooltip } from '@app/ui/tooltip';

// `#2A6BBF` has no theme token — one-off next to `PairRow.tsx`'s `INDICATOR_SX` (EVIDENCE.md).
const SENT_CUE_SX = { fontSize: 22, display: 'inline-flex', color: '#2A6BBF' };

export interface SentCueProps {
  readonly title: string;
}

export const SentCue = ({ title }: SentCueProps) => (
  <Tooltip title={title} color="inherit" iconSize="inherit">
    <TaskAlt sx={SENT_CUE_SX} />
  </Tooltip>
);
